import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Button, Form, Input, InputNumber, Select } from 'antd'
import { debounce } from 'lodash'
import { useCallback, useState } from 'react'
import { removeUndefinedValues, removeVietnameseTones } from '../../config-func'
import { identifierType } from './configs'
import styles from './styles.module.scss'
const { Option } = Select

const SearchForm = ({
  form,
  getListRequest = () => {},
  listDepartment,
  listRequest,
  cities,
  towns,
  districts,
  user,
  onChangePostType,
  listTypeRealEstate = [],
  onChangeCity,
  onChangeDistrict,
  onChangeDepartment,
  setPagination,
  pagination,
  LabelType,
  demandOps,
  typeOfRealEstateOps,
  apartmentLocationOptions,
  directionOptions,
  furnitureOptions,
  currentStatusOpstions,
  postStatusOptions,
  postSecurityOptions
}) => {
  // const [form] = Form.useForm()
  const [expanded, setExpanded] = useState(false)

  // const handleSearch = (values) => {
  //   const params = removeUndefinedValues(values)
  //   getListRequest(params)
  // }

  const handleSearch = useCallback(
    debounce((allValues) => {
      const { acreage, area_outside, ...data } = allValues
      const params = removeUndefinedValues({
        ...data,
        acreage_min: acreage,
        acreage_max: acreage,
        area_outside_min: area_outside,
        area_outside_max: area_outside,
        page: 1,
        pageSize: pagination.pageSize
      })

      // Reset pagination về trang 1 khi search
      if (pagination.current !== 1) {
        setPagination((prev) => ({ ...prev, current: 1 }))
      }
      getListRequest(params)
    }, 500),
    [pagination.current, pagination.pageSize, setPagination]
  )

  const handleReset = debounce(() => {
    form.resetFields()
    getListRequest()
  }, 300)

  const fields = [
    { label: 'ID', name: 'id', hidden: !expanded },
    // { label: 'Tên khách hàng', name: 'customer_name', hidden: !expanded },
    { label: 'Người đăng', name: 'customer_full_name', hidden: !expanded },
    { label: 'Số điện thoại', name: 'customer_phone_number' },
    { label: 'Email', name: 'customer_email' },
    // {
    //   label: 'Quản lý tin',
    //   name: 'manager_id',
    //   type: 'select',
    //   arr: user
    // },
    {
      label: 'Nhu cầu',
      name: 'request_type',
      type: 'select',
      arr: LabelType
      
      // hidden: !expanded
    },
    // {
    //   label: 'Tên Sàn',
    //   name: 'department_id',
    //   type: 'select',
    //   arr: listDepartment,
    //   onChange: onChangeDepartment
    // },
    {
      label: 'Loại BĐS',
      name: 'post_type',
      type: 'select',
      arr: typeOfRealEstateOps,
      onChange: onChangePostType
    },
    {
      label: 'Loại hình BĐS',
      name: 'type_real_estate',
      type: 'select',
      arr: listTypeRealEstate
    },
    { label: 'Số phòng ngủ', name: 'number_of_bedrooms' },
    // { label: 'Số WC', name: 'ko có' },
    { label: 'Số tầng', name: 'number_of_floor' },
    { label: 'Diện tích (m2)', name: 'acreage' },
    { label: 'Mặt tiền (m)', name: 'area_outside' },
    {
      label: 'Vị trí',
      name: 'apartment_location',
      type: 'select',
      arr: apartmentLocationOptions
    },

    {
      label: 'Hướng',
      name: 'direction',
      type: 'select',
      arr: directionOptions
    },
    // {
    //   label: 'Nội thất',
    //   name: 'furniture',
    //   type: 'select',
    //   arr: FURNITURE_TYPE
    // },
    // { label: 'Hướng ban công', name: 'balconyDirection', type: 'select' },

    {
      label: 'Tỉnh/Thành phố',
      name: 'city_code',
      type: 'select',
      arr: cities,
      onChange: onChangeCity
    },
    {
      label: 'Quận/Huyện',
      name: 'district_code',
      type: 'select',
      arr: districts,
      onChange: onChangeDistrict
    },
    { label: 'Phường/Xã', name: 'town_code', type: 'select', arr: towns },
    { label: 'Đường phố', name: 'street' },
 {
      label: 'Hiện trạng',
      name: 'web_status',
      type: 'select',
      arr: [{
        label: 'Đang hiển thị',
        value: 1
      },
      {
        label: 'Hết hạn',
        value: 999
      }]
    },
    {
      label: 'Xác thực định danh',
      name: 'identifier_type',
      type: 'select',
      arr: identifierType
    },
    // { label: 'Note', name: 'note' },
    { label: 'Mô tả', name: 'description' }
  ]

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      // labelCol={{ span: 8 }}
      // labelAlign="right"
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        if (value.city_code) {
          form.setFieldsValue({
            district_code: null,
            town_code: null
          })
        }
        if (value.district_code) {
          form.setFieldsValue({
            town_code: null
          })
        }
      }}
    >
      {expanded ? (
        <>
          <div className={styles.formAddFilter}>
            {fields.map((field, index) => (
              <Form.Item
                // labelCol={{ span: 8 }}
                label={field.label}
                name={field.name}
                style={{
                  marginBottom: 8,
                  display: field.hidden == true ? 'none' : 'block'
                }}
                className={styles.formItemFilter}
              >
                {
                  field.type === 'select' ? (
                    <Select
                      style={{ width: '100%' }}
                      placeholder={`Chọn ${field.label}`}
                      onChange={field.onChange}
                      showSearch={true}
                      allowClear={true}
                      filterOption={(input, option) => {
                        const inputValue =
                          removeVietnameseTones(input).toLowerCase()
                        const optionValue = removeVietnameseTones(
                          option?.children || ''
                        ).toLowerCase()
                        return optionValue.includes(inputValue)
                      }}
                    >
                      {field.arr && field.arr.length > 0 ? (
                        field.arr.map((item, idx) => (
                          <Option key={idx} value={item.value}>
                            {item.label}
                          </Option>
                        ))
                      ) : (
                        <>
                          {/* <Option value="option1">Option 1</Option>
                        <Option value="option2">Option 2</Option> */}
                        </>
                      )}
                    </Select>
                  ) : field.name == 'acreage' ||
                    field.name == 'area_outside' ? (
                    <InputNumber
                      onBlur={(e) => {
                        const value = parseFloat(e.target.value?.trim())
                        form.setFields([
                          {
                            name: field.name,
                            value: isNaN(value) ? 0 : value
                          }
                        ])
                      }}
                      className={styles.InputNumber}
                      formatter={(value) =>
                        value ? value.replace(/[^0-9.]/g, '') : ''
                      }
                      parser={(value) => value.replace(/[^0-9.]/g, '.')}
                      placeholder="Nhập diện tích"
                    />
                  ) : (
                    <Input
                      placeholder={`Nhập ${field.label.toLowerCase()}`}
                      onBlur={(e) => {
                        form.setFields([
                          {
                            name: field.name,
                            value: e.target.value?.trim()
                          }
                        ])
                      }}
                    />
                  )
                  // <Input placeholder={`Nhập ${field.label}`} />
                }
              </Form.Item>
            ))}
            <Form.Item
              label=""
              name=""
              className={styles.formItemFilter}
            ></Form.Item>
            <div
              className={styles.formItemFilter}
              style={{ textAlign: 'right', marginBottom: 8 }}
            >
              <Button onClick={handleReset}>Đặt lại</Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: '0 8px' }}
              >
                Tìm kiếm
              </Button>
              <span
                className="d-flex"
                style={{ color: '#08c', cursor: 'pointer' }}
                onClick={() => setExpanded(!expanded)}
              >
                Thu nhỏ{' '}
                <UpOutlined style={{ fontSize: '14px', color: '#08c' }} />
              </span>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            // display: 'flex',
            // margin: '-0 8px',
            // justifyContent: 'space-between'
            display: 'flex',
            // margin: '-0 8px',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            // gap: 16,
            alignItems: 'center'
          }}
        >
          <Form.Item label="ID" name="id" className={styles.formItemFilter}>
            <Input
              placeholder="Nhập ID"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'id',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <Form.Item
            label="Người đăng"
            name="customer_full_name"
            className={styles.formItemFilter}
          >
            <Input
              placeholder="Nhập người đăng"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'customer_full_name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <Form.Item
            label="Số điện thoại"
            name="customer_phone_number"
            className={styles.formItemFilter}
          >
            <Input
              placeholder="Nhập Điện thoại"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'customer_phone_number',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <div
            className={styles.formItemFilter}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
            <span
              className="d-flex"
              style={{ color: '#08c', cursor: 'pointer' }}
              onClick={() => setExpanded(!expanded)}
            >
              Mở rộng{' '}
              <DownOutlined style={{ fontSize: '14px', color: '#08c' }} />
            </span>
          </div>
          {/* )} */}
        </div>
      )}
    </Form>
  )
}

export default SearchForm
